import { useEffect, useState, useCallback } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import { plusIcon, refreshIcon, refreshinrefils } from "../../landingscreen/modals/svgs";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { PharmacyModal } from "./modals/pharmacymodal";
import { PrescriptionModal } from "./modals/PrescriptionModal";
import { useSelector } from "react-redux";
import moment from "moment";
const Refillstab = ({ data, appointmentId, startDate, setShowOrders }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [Backdroploading,setBackdropLoading]=useState(false)
  useParams(); // Keep for potential future use
  const [respdata, setrespdata] = useState([]);
  console.log("respdata",respdata);
  
  const [visibleInputIndex, setVisibleInputIndex] = useState(null);
  const [filtercounts,setFilterCounts]=useState({"total_medications": 0,
        "active_medications": 0,
        "inactive_medications": 0})
  const [isPharmacySelected, setIspharmacySelected] = useState(false);
  const [pharmacyText, setPharmacyText] = useState("");
  const [pharmacySuggestions, setPharmacySuggestions] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("all");
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const practiseid = window.getPracticeId();
  const params = useParams();
  const dt = params.dt || startDate ;
 const userConfig = useSelector((state) => state.userconfig);
 const[selectedpharma,setSelectedPharma]=useState('')
 const [isaddpharma,setIsAddPharma]=useState(false)
 const[pharmadetails,setPharmaDetails]=useState({})
 const tabs=[
              { key: "requested", label: "Requested",prop:"req", count: filtercounts.requested_medications },
            { key: "all", label: "All",prop:"", count: filtercounts.total_medications },
 { key: "active", label: "Active",prop:"A", count: filtercounts.active_medications },
 { key: "inactive", label: "In Active", prop:"I",count: filtercounts.inactive_medications },
//  { key: "pending", label: "Pending", prop:"",count: pendingCount }
            ]
 const normalizeResponse = (data) => {
  if (!data) return [];

  const statusMap = {};
  (data.medicationstatus || []).forEach((s) => {
    statusMap[s.medicationentryid] = s;
  });

  return (data.medicationdata || []).map((med) => ({
    ...med,
    ...statusMap[med.medicationentryid], // merge status info by ID
  }));
};

  const fetchData = async({status=false,filter=undefined}) => {
    try {
      if(!status){
          setIsLoading(true)
              await api.post(`v1/${practiseid}/medications/patient/${data.patientid}/sync-medication`)
      }else{
        setBackdropLoading(true)
      }
   const countsresponse= await api.get(`/v1/${practiseid}/medications/patient/${data.patientid}/count`)
   if(countsresponse.status==200){
    setFilterCounts(countsresponse.data)
   }else{
    setFilterCounts({"total_medications": 0,
        "active_medications": 0,
        "inactive_medications": 0})
   }
  const params = {};

if (filter !== undefined && filter !== null && filter !== "") {
  params.status = filter;
}

const response = await api.get(
  `/v1/${practiseid}/medications/patient/${data.patientid}/refills`,
  { params }
)
      if (response.status === 200) {
    const merged = normalizeResponse(response.data);
      setrespdata(merged);
      console.log(merged,'d')
      } else {
        setrespdata([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBackdropLoading(false)
      setIsLoading(false);
    }
  }

const fetchpharmacydata=async()=>{
try {
  const response=await api.get(`/v1/${practiseid}/rx/patient/${data.patientid}/department/${userConfig.config.departmentid}/pharmacy`)
  if(response.status==200){
setPharmaDetails(response.data||{})
  }else{
setPharmaDetails({})
  }
} catch (error) {
  console.log(error)
}
}
useEffect(()=>{
  if(data.patientid&&practiseid){
  fetchData({status:false})
  fetchpharmacydata()
  }
console.log('dtaaa',data)
},[data.patientid])

  const fetchPharmacySuggestions = async () => {
    if (pharmacyText.trim().length > 1) {
      // Trigger API only after 3 characters
      try {
        const response = await api.post(
          `/v1/${practiseid}/rx/patient/${data.patientid}/department/${data.departmentid}/pharmalook`,
          {
            facility_name: pharmacyText,
          }
        );
        if (response.status === 200) {
          setPharmacySuggestions(response.data.slice(0, 5) || []);
        }else{
           setPharmacySuggestions([])
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    }
  }

  const toggleInputVisibility = (index) => {
    setVisibleInputIndex(visibleInputIndex === index ? null : index); // Toggles visibility for the clicked card
  };
  const updatePharmacy = async (obj) => {

    setIsLoading(true)
    try {
      await api.post(`/v1/${practiseid}/patients/${data?.patientid}/pharmacies/default`, {
  "departmentid":userConfig.config.departmentid,
  "clinicalproviderid":selectedpharma?.facilityid
      });
    } catch (error) {
      console.log(error);
    } finally {
    fetchpharmacydata()
      setPharmacyText("");
      setSelectedPharma('')
    setIsLoading(false)
    }
  };
  const updateDuration = async (obj) => {
    try {
      await api.put(`/v1/${practiseid}/patient/refills/duration`, obj);
    } catch (error) {
      console.log(error);
    } finally {

    }
  };
  const markstatus=async(x)=>{
    try {
      setBackdropLoading(true)
 const formData = new FormData();

Object.entries(x).forEach(([key, value]) => {
  formData.append(key, value);
});
formData.append("orderdate",dt)
formData.append("pat_name",userConfig.username)
formData.append("userprovider",x.refil == "Y" ? 1 : 0);

const response = await api.post(
  `/v1/${practiseid}/medications/patient/${data.patientid}/update`,
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data", // 👈 force it if axios defaults block
    },
  }
);

    } catch (error) {
      console.log(error)
    }finally{
      setBackdropLoading(false)
      const selectedfilter= tabs.find(t=>t.key==activeTabKey)
      fetchData({status:true,filter:selectedfilter?.prop})

    }
  }

  // Calculate summary statistics
  const pendingCount =
    respdata?.filter((item) => item.refil === "Y" && item.active === "A")
      .length || 0;
  const approvedCount = 0; // This would need to be tracked separately
  const cancelledCount = 0; // This would need to be tracked separately
  const totalCount = respdata?.length || 0;
  const activeCount =
    respdata?.filter((item) => item.active === "A").length || 0;
  const inactiveCount =
    respdata?.filter((item) => item.active !== "A").length || 0;

  return (
    <>
      <div className="bg-gray-50 min-h-screen p-6">
        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white p-2 rounded-xl border border-[#E5E7EB] text-left">
            <div className="text-[22px] font-font1 font-semibold text-[#155DFC]">
              {filtercounts?.pending_refills||0}
            </div>
            <div className="text-sm font-font1 font-[300] text-[#4A5565]">
              Pending Refills
            </div>
          </div>
          <div className="bg-white p-2 rounded-xl border border-[#E5E7EB] text-left">
            <div className="text-[22px] font-font1 font-semibold text-[#00A63E]">
              {filtercounts?.approved_today||0}
            </div>
            <div className="text-sm font-font1 font-[300] text-[#4A5565]">
              Approved Today
            </div>
          </div>
          <div className="bg-white p-2 rounded-xl border border-[#E5E7EB] text-left">
            <div className="text-[22px] font-font1 font-semibold text-[#E7000B]">
              {filtercounts?.cancelled_today||0}
            </div>
            <div className="text-sm font-font1 font-[300] text-[#4A5565]">
              Cancelled Today
            </div>
          </div>
          <div className="bg-white p-2 rounded-xl border border-[#E5E7EB] text-left">
            <div className="text-[22px] font-font1 font-semibold text-[#4A5565]">
          {(filtercounts?.pending_refills || 0) + 
 (filtercounts?.approved_today || 0) + 
 (filtercounts?.cancelled_today || 0)}

            </div>
            <div className="text-sm font-font1 font-[300] text-[#4A5565]">
              Total Requests
            </div>
          </div>
        </div>

        <div className="bg-white p-3 rounded-xl border border-[#E5E7EB] text-left mb-6">
          <div className="flex justify-between items-center">
            <div className="flex flex-col">
              <span className="text-base font-font1 font-medium text-[#101828]">
             {pharmadetails?.clinicalprovidername||'-'}
              </span>
              <span className="text-xs font-normal text-[#4A5565] font-font1 leading-4">
              {pharmadetails?.address1||'-'}
              </span>
            </div>

            <div className="flex gap-3">
              <button
              onClick={()=>{setIsAddPharma(true)}}
              className="bg-[#00B8DB] text-white px-3 py-2 rounded-xl font-font1 text-sm font-medium focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none">
                Default Pharmacy
              </button>
            </div>
          </div>
        </div>

        {/* Filter Tabs */}
        {/* Filter Tabs */}
        <div className="flex justify-between items-center mb-6 p-3">
          <div className="flex gap-2">
            {tabs.map((t) => {
              const selected = activeTabKey === t.key;
              return (
                <button
                  key={t.key}
                  onClick={() => {
                    setActiveTabKey(t.key)
                  if(t.prop){
                    fetchData({status:false,filter:t.prop})
                  }else{
                    fetchData({status:false})
                  }
                  }}
                  className={[
                    "px-3 py-2 rounded-xl font-font1 text-sm font-medium inline-flex items-center gap-2 transition-colors focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none",
                    selected
                      ? "bg-[#E17954] text-white"
                      : "bg-[#F1F5F9] text-[#1F2937]",
                  ].join(" ")}
                >
                  <span>{t.label}</span>
                  <span
                    className={[
                      "inline-flex items-center justify-center rounded-full text-[11px] font-font1 min-w-[25px] h-[25px]",
                      selected
                        ? "bg-[#FFFFFF33] text-white"
                        : "bg-[#E5E7EB] text-[#4A5565]",
                    ].join(" ")}
                  >
                    {t.count}
                  </span>
                </button>
              );
            })}

            <div
            onClick={()=>{
              setActiveTabKey("all")
               fetchData({status:false,filter:''})
            }}
            
            className=" text-[#374151] cursor-pointer px-3 py-2 rounded-xl text-sm font-medium font-font1 inline-flex items-center gap-2 ">
              {refreshinrefils}
              Refresh
            </div>
          </div>

          <button
            onClick={() => setShowPrescriptionModal(true)}
            className="bg-[#00A63E] text-white px-2 py-2 rounded-xl font-font1 text-sm font-medium inline-flex items-center gap-2 focus:outline-none focus:ring-0 focus:ring-offset-0 focus-visible:outline-none"
          >
            {plusIcon} Add Medication
          </button>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
          {isLoading ? (
            <div className="flex justify-center items-center p-8">
              <div className="text-gray-500">Loading...</div>
            </div>
          ) : respdata?.length ? (
            <>
              <div className="overflow-x-auto">
                <div className="max-h-96  custom-scroll">
                  <table className="w-full shadow-md rounded-md">
                    <thead className="bg-[#ffffff] border-b border-[#E5E7EB] ">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium font-font1 text-[#364153] uppercase tracking-wider">
         <button
        className={[
          "w-5 h-5 flex items-center justify-center rounded-md transition-colors",
          respdata.every(res => res.refillApprove=='Y')
            ? "bg-[#0B0B1A] text-white"
            : "bg-white border border-gray-300",
        ].join(" ")}
      >
        {respdata.every(res => res.refillApprove=='Y') && (
          <svg
            width="8"
            height="7"
            viewBox="0 0 8 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.10223 1.21094L2.50848 5.80469L0.42041 3.71662"
              stroke="white"
              strokeWidth="0.835227"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>   
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium font-font1 text-[#364153] uppercase tracking-wider">
                          MEDICATION
                        </th>
                        
                        <th className="px-6 py-3 text-left text-xs font-medium font-font1 text-[#364153] uppercase tracking-wider">
                          QUANTITY
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium font-font1 text-[#364153] uppercase tracking-wider">
                          DURATION
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium font-font1 text-[#364153] uppercase tracking-wider">
                          STATUS
                        </th>
                        <th className="px-6 py-3 text-center text-xs font-medium font-font1 text-[#364153] uppercase tracking-wider">
                          ACTIONS
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-[#E5E7EB]">
                      {respdata.map((res, index) => (
                        <tr key={index}>
                             <td className="px-6 py-4 whitespace-nowrap text-left">
                            <button
                          
                              className={[
                                "w-5 h-5 flex items-center justify-center rounded-md transition-colors",
                                res.refillApprove=='Y'
                                  ? "bg-[#0B0B1A] text-white"
                                  : "bg-white border border-gray-300",
                              ].join(" ")}
                            >
                              {res.refillApprove=='Y' && (
                                
                                <svg
                                  width="8"
                                  height="7"
                                  viewBox="0 0 8 7"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.10223 1.21094L2.50848 5.80469L0.42041 3.71662"
                                    stroke="white"
                                    stroke-width="0.835227"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              )}
                            </button>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-left">
                            <div>
                              <div className="text-sm font-font1 font-medium text-[#101828]">
                                {res?.medication}
                              </div>
                              {res?.created_at == null ? "" : <div className="text-xs font-font1 font-light text-[#6A7282]">
                                Requested: {moment(res?.created_at).format("MM/DD/YYYY")}
                              </div>}
                            </div>
                          </td>
                       

                          <td className="px-6 py-4 whitespace-nowrap">
                           {(() => {
  const match = res.unstructuredsig?.match(/\b\d+\b/);
  if (!match) return null; // don't render anything if no number
  return (
    <div className="w-14 text-center border border-gray-300 rounded-lg px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
      {match[0]}
    </div>
  );
})()}

                          </td>

                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
  {(() => {
    const match = res?.unstructuredsig?.match(/(\d+\s*days?)/i);
    return match ? match[0] : '';
  })()}
</td>

                          <td className="px-6 py-4 whitespace-nowrap text-left">
                           {res.refillApprove=='Y'?<><span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-font1 bg-green-400 text-white">
                             Approved
                            </span></>: <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-font1 bg-[#FEF9C2] text-[#894B00]">
                              Pending
                            </span>}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <div className="w-full flex justify-center gap-2">


                            
                                <>
                                  {<button
                                    onClick={() => {
                                    let obj={
                                  patientid:data?.patientid,
                                  practiseid:practiseid,
                                  medicationentryid :res.medicationentryid,
                                 userprovider:0,
                         status:'A',
                         refill:'Y'
                                }
                                markstatus(obj)
                                    }}
                                           disabled={res.refillApprove=='Y'}
             className={`px-3 py-2 rounded-xl text-sm font-medium inline-flex items-center gap-1 ${
    res.refillApprove === 'Y'
      ? 'bg-[#6B7280] cursor-not-allowed text-white'
      : 'bg-[#00A63E] text-white hover:bg-[#008936]'
  }`}
                                  >
                                    <CheckIcon fontSize="small" />
                                    Approve
                                  </button>}
                                   {/* <button
                                    onClick={() => {
                                 let obj={
                                  patientid:data?.patientid,
                                  practiseid:practiseid,
                                  medicationentryid :res.medicationentryid,
                                  status:res.status==='A'?"I":"A",
                                  refill:res.status==='A'?"Y":"N"
                                }
                                markstatus(obj)
                                    }}
                                    disabled={res.refillApprove=='Y'}
className={`px-3 py-2 rounded-xl text-xs font-medium inline-flex items-center gap-1 ${
    res.refillApprove === 'Y' ? 'bg-[#6B7280] cursor-not-allowed' : 'bg-[#E17954] text-white'
  }`}
                                  >
                                    <CloseIcon fontSize="small" />
                                    Inactive
                                  </button> */}
                                  <button
                                        onClick={() => {
                                 let obj={
                                  patientid:data?.patientid,
                                  practiseid:practiseid,
                                  medicationentryid :res.medicationentryid,
                                  status:"I",
                                  refill:res.status==="N"
                                }
                                markstatus(obj)
                                    }}
                                  // disabled={res.refillApprove!='Y'}
                                    className="bg-[#E7000B] text-white px-3 py-2 rounded-xl text-xs font-medium  inline-flex items-center gap-1"
                                  >
                                    <CloseIcon fontSize="small" />
                                    Reject
                                  </button>
                                </>
                            
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {isaddpharma && (
                <PharmacyModal

                  pharmacyText={pharmacyText}
                  setPharmacyText={setPharmacyText}
                  pharmacySuggestions={pharmacySuggestions}
                  setPharmacySuggestions={setPharmacySuggestions}
                  isPharmacySelected={isPharmacySelected}
                  setIspharmacySelected={setIspharmacySelected}
                  updatePharmacy={updatePharmacy}
                  visibleInputIndex={visibleInputIndex}
                  respdata={respdata}
                  onClose={() => setIsAddPharma(false)}
                  setSelectedPharma={setSelectedPharma}
                  fetchPharmacySuggestions={fetchPharmacySuggestions}
                />
              )}

              {showPrescriptionModal && (
                <PrescriptionModal
                selectedpharma={pharmadetails}
                userdata={data}
                isOpen={showPrescriptionModal}
                  onClose={() => setShowPrescriptionModal(false)}
                />
              )}

              <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center">
                <div className="text-sm text-gray-600">
                  {pendingCount} pending refill(s) require attention
                </div>
                <div className="flex gap-3">
                  <button className="bg-[#00A63E] text-white px-3 pt-2 pb-1 rounded-xl text-sm font-font1 font-medium">
                    Approve All Pending
                  </button>
                  <button className="bg-[#ffffff] border-[2px] border-[#FFC9C9] text-[#E7000B] px-3 pt-2 pb-1 rounded-xl text-sm font-font1 font-medium">
                    Cancel All Pending
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div className="flex justify-center items-center p-8">
              <div className="text-gray-500">No data available</div>
            </div>
          )}
        </div>
      </div>
      {/* { respdata?.length?<div className="w-full flex justify-center gap-8 sm:gap-10 mt-4">

                    <button
                        className="rounded-full w-[120px] bg-white text-black border-2 border-black py-2 px-4 transition duration-300 ease-in-out hover:text-white hover:bg-gray-800">
                        Close
                    </button>

                    <button

                        className="rounded-full w-[120px] bg-black text-white py-2 px-4 transition duration-300 ease-in-out hover:bg-gray-800">
                        Save
                    </button>
                </div>:<></>} */}
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading||Backdroploading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
    </>
  );
};
export default Refillstab;
